<template>
  <div class="ai-chat-overlay" @click.self="closeModal">
    <div class="ai-chat-modal dark" role="dialog" aria-modal="true">
      <div class="ai-chat-header">
        <div class="ai-chat-title">AIチャット インフルエンサー検索</div>
        <button type="button" class="ai-chat-send" @click="confirmResetChat()">最初からやり直す</button>
      </div>
      <div class="ai-chat-body" ref="chatBody">
        <div
          v-for="(message, index) in messages"
          :key="index"
          class="ai-chat-row"
          :class="[
            message.side === 'right' ? 'right' : 'left',
            message.type === 'link' ? 'link' : ''
          ]"
        >
          <div
            class="ai-chat-avatar"
            :class="message.side === 'right' ? 'right' : 'left'"
          >
            <i v-if="message.side === 'right'" class="el-icon-user"></i>
            <i v-else class="el-icon-s-comment"></i>
          </div>
          <div v-if="message.type === 'link'" class="ai-chat-bubble ai-chat-link-bubble">
            <button
              type="button"
              class="ai-chat-link-button"
              @click="searchBySuggest(message)"
            >
              {{ message.text || 'リンクを開く' }}
            </button>
          </div>
          <div v-else class="ai-chat-bubble">
            <div class="ai-chat-text">{{ message.text }}</div>
          </div>
        </div>
        <div v-if="isLoading" class="ai-chat-row left">
          <div class="ai-chat-avatar left">
            <i class="el-icon-s-comment"></i>
          </div>
          <div class="ai-chat-bubble ai-chat-loading-bubble">
            <span class="ai-chat-loading-dot"></span>
            <span class="ai-chat-loading-dot"></span>
            <span class="ai-chat-loading-dot"></span>
          </div>
        </div>
      </div>
      <div class="ai-chat-input">
        <input
          id="user-question"
          type="text"
          class="ai-chat-input-field"
          v-model="question"
          placeholder="メッセージを入力"
          @keydown.enter.stop="onQuestionEnter"
        />
        <button
          type="button"
          @click="sendChat()"
          class="ai-chat-send"
          :class="{ 'is-loading': isLoading }"
          :disabled="isLoading"
        >送信</button>
      </div>
    </div>
  </div>
</template>

<script>

const root = process.env.VUE_APP_API;
const SuggestSearchConfigAPI = root + "/api/search/suggest_search_condition_chat";

const CHAT_STATUS = {
  RELOAD: 1,
  RESET: 2,
  QUESTION: 4,
  CHECK: 5,
};
const DEFAULT_TRACE_ID = "0_0";
const DEFAULT_VERSION = "0.0.0";

export default {
  name: "aiChat",
  props: {
    snsType: {
      type: String
    }
  },
  data() {
    return {
      question: "",
      defaultMessage: "どのようなインフルエンサーを探していますか？",
      isLoading: false,
      appendedToBody: false,
    };
  },
  mounted(){
    this.appendToBody();
    this.load();
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    messages(){
      return this.$store.state.aiChat.logs[this.snsType].messages;
    },
    trace_id() {
      return this.$store.state.aiChat.logs[this.snsType].trace_id;
    },
    version(){
      return this.$store.state.aiChat.version;
    }
  },
  methods: {
    appendToBody() {
      if (!this.$el || this.appendedToBody || typeof document === "undefined") {
        return;
      }
      document.body.appendChild(this.$el);
      this.appendedToBody = true;
    },
    onQuestionEnter(event) {
      if (event && (event.isComposing || event.keyCode === 229)) {
        return;
      }
      if (event) {
        event.preventDefault();
      }
      this.sendChat();
    },
    closeModal() {
      this.$emit("close");
    },
    load(){
      // 最新データか確認
      this.getSuggestSearchCondfig(
        CHAT_STATUS.CHECK,
        res => {
          if(res.data.logId === 0){
            // アクティブなログ無し一応。localstrageリセット
            this.reloadChat();
          }else{
            // traceIdを更新
            this.$store.dispatch("setAiChatTraceId", {
              snsType: this.snsType,
              trace_id: res.data.traceId,
            });
            // messagesがないならデータ消えてる。再取
            if(this.messages.length === 0){
            // アクティブなログ無し一応。localstrageリセット
              this.reloadChat();
            }else if( this.messages[this.messages.length-1].logId === res.data.logId) {
              // OK
              this.renderMessage();
            }else{
              // 一致しないならデータ欠けの可能性。サーバから再取得
              this.reloadChat();
            }
          }
        },
        err => {}
      );
    },
    reloadChat(){
      this.getSuggestSearchCondfig(
        CHAT_STATUS.RELOAD,
        res => {
          // ブラウザ履歴を消して
          this.$store.dispatch("resetAiChatMessage", this.snsType);
          // start
          this.startChat()
          this.$store.dispatch("setAiChatTraceId", {
            snsType: this.snsType,
            trace_id: res.data.traceId,
          });
          if( res.data.history && res.data.history.length > 0) {
            res.data.history.forEach(log => {
              this.addUserMessage(log.user_question);
              this.addAiMessage(log.no, log.hit_count, log.ai_response);
              this.addLinkMessage(log.no, log.condition);
            })
          }
        },
        err => {}
      );
    },
    startChat(){
      // 会話開始するだけ
      this.addMessage({side: "left", text: this.defaultMessage});
    },
    confirmResetChat(){
      if (this.isLoading) {
        return;
      }
      this.$confirm(
        "現在のチャット履歴が消去され、新しい会話が始まります。この操作は取り消せません。",
        "チャットを最初からやり直しますか？",
        {
          cancelButtonText: "キャンセル",
          confirmButtonText: "最初からやり直す",
          type: "warning",
        }
      )
        .then(() => {
          this.resetChat();
        })
        .catch(() => {});
    },
    resetChat(){
      // 会話リセット
      // サーバ側でセッション終了させて
      this.isLoading = true;
      this.getSuggestSearchCondfig(
        CHAT_STATUS.RESET,
        res => {
          this.question = "";
          this.isLoading = false;
          this.$store.dispatch("setAiChatTraceId", {
            snsType: this.snsType,
            trace_id: DEFAULT_TRACE_ID,
          });
          // ブラウザ履歴を消して
          this.$store.dispatch("resetAiChatMessage", this.snsType);
          // start
          this.startChat()
        },
        err => {}
      );
    },
    sendChat(){
      // 空欄判定 連打判定
      if( this.question === "" || this.isLoading ){
        return ;
      }
      this.addUserMessage(this.question)
      this.isLoading = true;
      this.renderMessage();

      this.getSuggestSearchCondfig(
        CHAT_STATUS.QUESTION,
        res => {
          this.question = "";
          this.isLoading = false;

          this.addAiMessage(res.data.logId, res.data.hitCount, res.data.assistantMessage);
          this.addLinkMessage(res.data.logId, res.data.condition);
          if(this.trace_id === DEFAULT_TRACE_ID) {
            this.$store.dispatch("setAiChatTraceId", {
              snsType: this.snsType,
              trace_id: res.data.traceId,
            });
          }
        },
        err => {}
      );
    },
    addUserMessage(message){
      this.addMessage({side: "right", text: message})
    },
    addAiMessage(logId, hitCount, assistantMessage){
      const aiResponse = "ありがとうございます。" + 
        hitCount + "件hitしました。" + assistantMessage + 
        "\n追加で絞り込む場合は続けて入力してください。";
      this.addMessage({
        side: "left",
        logId: logId,
        text: aiResponse,
      })
    },
    addLinkMessage(logId, condition){
      this.addMessage({
        side: "button",
        text: 'この条件で検索する',
        type: 'link',
        logId: logId,
        condition: condition
      })
    },
    addMessage(message){
      this.$store.dispatch("addAiChatMessage", {
        snsType: this.snsType,
        message: message
      });
      this.renderMessage();
    },
    renderMessage(){
      this.$nextTick(() => {
        const el = this.$refs.chatBody;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
    searchBySuggest(message){
      // モーダルを消す
      this.closeModal();
      // 検索結果に移動する
      this.$emit("search", message.condition);
    },
    getSuggestSearchCondfig(status, responseFunc, errorFunc){
      this.axios
        .get(SuggestSearchConfigAPI, {
          params: {
            sns_type: this.snsType,
            trace_id: this.trace_id,
            message: this.question,
            status: status,
            token: this.token,
            user_token: this.user_token,
          }
        })
        .then((response) => {
          if(response.data.status === "ok"){
            this.checkVersion(response.data.version);
            responseFunc(response);
          }else{
            console.log(response.data.error);
            this.addMessage({
              side: "left",
              text: "通信に失敗しました。時間をおいて再度お試しください。"
            });
            this.isLoading = false;

          }
        })
        .catch(e => {
          console.log(e )
          errorFunc(e);
          this.addMessage({
            side: "left",
            text: "通信に失敗しました。時間をおいて再度お試しください。"
          });
          this.isLoading = false;
        });
    },
    checkVersion(version){
      if( this.version === DEFAULT_VERSION ){
        this.$store.dispatch("setAiChatVersion", version);
      }
    },
  },
  beforeDestroy() {
    if (this.appendedToBody && this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  }
};
</script>

<style scoped>
.ai-chat-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.ai-chat-modal {
  width: 70%;
  min-height: 220px;
  max-height: calc(100vh - 16px);
  height: auto;
  margin-right: 10%;
  background: #ffffff;
  border-left: 1px solid #eee;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ai-chat-modal.dark {
  background: #151b26;
  border-left-color: #1f2a36;
}

.ai-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  font-weight: 700;
}

.ai-chat-modal.dark .ai-chat-header {
  border-bottom-color: #1f2a36;
}

.ai-chat-title {
  font-size: 16px;
  color: #333;
}

.ai-chat-modal.dark .ai-chat-title {
  color: #f0f3f7;
}

.ai-chat-close {
  border: none;
  background: transparent;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #666;
}

.ai-chat-close:hover {
  color: #333;
}

.ai-chat-modal.dark .ai-chat-close {
  color: #9aa7b4;
}

.ai-chat-modal.dark .ai-chat-close:hover {
  color: #f0f3f7;
}

.ai-chat-body {
  flex: 0 1 auto;
  max-height: calc(100vh - 180px);
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: #333;
}

.ai-chat-modal.dark .ai-chat-body {
  color: #e1e6ee;
}

.ai-chat-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.ai-chat-row.right {
  flex-direction: row-reverse;
}

.ai-chat-row.link .ai-chat-avatar {
  visibility: hidden;
}

.ai-chat-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e9eef2;
  color: #4b5a6a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex: 0 0 auto;
}

.ai-chat-avatar i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
}

.ai-chat-modal.dark .ai-chat-avatar {
  background: #2b3a49;
  color: #d7e0ea;
}

.ai-chat-bubble {
  max-width: 70%;
  background: #f3f6f9;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ai-chat-loading-bubble {
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.ai-chat-loading-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #8a96a3;
  opacity: 0.4;
  animation: ai-chat-dot 1.2s infinite ease-in-out;
}

.ai-chat-loading-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.ai-chat-loading-dot:nth-child(3) {
  animation-delay: 0.4s;
}

.ai-chat-modal.dark .ai-chat-loading-dot {
  background: #93a2b3;
}

.ai-chat-row.right .ai-chat-bubble {
  background: #dfe9f7;
}

.ai-chat-modal.dark .ai-chat-bubble {
  background: #1f2a36;
}

.ai-chat-modal.dark .ai-chat-row.right .ai-chat-bubble {
  background: #223243;
}

@keyframes ai-chat-dot {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
}

.ai-chat-link-bubble {
  background: transparent;
  padding: 0;
}

.ai-chat-link-button {
  display: inline-block;
  width: 100%;
  background: #67c23a;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}

.ai-chat-link-button:hover {
  opacity: 0.9;
}

.ai-chat-text {
  font-size: 13px;
  line-height: 2.5;
  white-space: pre-line;
}

.ai-chat-time {
  font-size: 11px;
  color: #8a96a3;
  text-align: right;
}

.ai-chat-modal.dark .ai-chat-time {
  color: #93a2b3;
}

.ai-chat-input {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #eee;
}

.ai-chat-modal.dark .ai-chat-input {
  border-top-color: #1f2a36;
}

.ai-chat-input-field {
  flex: 1;
  height: 34px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  padding: 0 10px;
  font-size: 13px;
  background: #fff;
  color: #333;
}

.ai-chat-modal.dark .ai-chat-input-field {
  background: #111923;
  border-color: #2b3a49;
  color: #e1e6ee;
}

.ai-chat-send {
  height: 34px;
  padding: 0 14px;
  border-radius: 6px;
  border: none;
  background: #2f6bff;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}

.ai-chat-send.is-loading,
.ai-chat-send:disabled {
  background: #a7b8d8;
  cursor: not-allowed;
}

.ai-chat-send:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .ai-chat-overlay {
    padding: 8px 0 0;
  }

  .ai-chat-modal {
    width: calc(100% - 16px);
    margin-right: 8px;
    max-height: calc(100vh - 8px);
  }

  .ai-chat-body {
    max-height: calc(100vh - 168px);
  }
}
</style>
